export default "__VITE_ASSET__BcGaYBWt__"